/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconClockHour1 = createReactComponent("clock-hour-1", "IconClockHour1", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M12 7v5", key: "svg-1" }],
  ["path", { d: "M12 12l2 -3", key: "svg-2" }]
]);

export { IconClockHour1 as default };
//# sourceMappingURL=IconClockHour1.js.map
